import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export function useLocationStateBanner({ config, stateKey }) {
  const navigate = useNavigate();
  const { state, pathname } = useLocation();

  const [bannerReason, setBannerReason] = useState(
    () => state?.[stateKey] ?? null,
  );

  useEffect(() => {
    if (state?.[stateKey]) {
      navigate(pathname, { replace: true, state: {} });
    }
  }, []);

  const banner = config[bannerReason] ?? null;

  return {
    banner,
    dismissBanner: () => setBannerReason(null),
  };
}
